import type { FC } from 'react';

import { Hotkey } from 'config/enums';
import { CallDetailsButtonConnect } from 'features/call/call-details/components';

interface CallDetailsButtonCalleeConnectProps {
  isLoading: boolean;
  onClickHandler: () => void;
  hotkey?: Hotkey;
}
export const CallDetailsButtonCalleeConnect: FC<
  CallDetailsButtonCalleeConnectProps
> = ({
  isLoading,
  onClickHandler,
  hotkey = Hotkey.CalleeConnectionStateChange,
}) => {
  return (
    <CallDetailsButtonConnect
      loading={isLoading}
      onClick={onClickHandler}
      hotkey={hotkey}
    />
  );
};
